<template>
    <div class="wrapper">
        <header>
            <nav class="topnav">
                <router-link class="brand" :to="{ name: 'home' }"
                    >&lt;slic-vic /&gt;</router-link
                >
                <ul class="nav">
                    <li>
                        <router-link
                            class="cool-link"
                            :to="{ name: 'home' }"
                            :class="{ active: $route.name === 'home' }"
                            >Work</router-link
                        >
                    </li>
                    <li>
                        <router-link
                            class="cool-link"
                            :to="{ name: 'about' }"
                            :class="{ active: $route.name === 'about' }"
                            >About</router-link
                        >
                    </li>
                    <li>
                        <router-link
                            class="cool-link"
                            :to="{ name: 'blog' }"
                            :class="{ active: $route.name === 'blog' }"
                            >Blog</router-link
                        >
                    </li>
                    <li class="is-icon">
                        <a href="https://github.com/slicvic" target="_blank">
                            <i class="fab fa-github"></i>
                        </a>
                    </li>
                </ul>
            </nav>
        </header>
        <main class="main">
            <transition name="fade" mode="out-in">
                <router-view />
            </transition>
        </main>
        <footer>
            <i>
                &ldquo;There is no magic in magic, it's all in the
                details&rdquo;
            </i>
            <br />
            &mdash;Walt Disney
        </footer>
    </div>
</template>

<script>
export default {
    name: 'App',
}
</script>
